
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whos-wearing-generation-tux",
      function () {
        return require("private-next-pages/whos-wearing-generation-tux/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whos-wearing-generation-tux"])
      });
    }
  